import React, { useState } from "react";
import { motion } from "framer-motion";
import TopContent from "./TopContent";
import ResultCard from "./ResultCard";
import useCircleRateCalculator from "./hooks/useCircleRateCalculator";
import CityLocalityFields from "./CirCalupart/CityLocalityFields";
import PropertyAreaFields from "./CirCalupart/PropertyAreaFields";
import ContactFormModal from "./CirCalupart/ContactFormModal";
import UnitSelection from "./CirCalupart/UnitSelection";

const CircleRateCalculator = () => {
  const {
    city,
    locality,
    propertyType,
    area,
    unit,
    result,
    setCity,
    setLocality,
    setPropertyType,
    setArea,
    setUnit,
    handleCityChange,
    handleCalculate,
    handleReset,
  } = useCircleRateCalculator();

  const [credits, setCredits] = useState(0);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  const onCalculateClick = () => {
    if (credits > 0 || formSubmitted) {
      handleCalculate();
      if (credits > 0) setCredits(credits - 1);
    } else {
      setShowContactForm(true);
    }
  };

  const closeContactForm = () => setShowContactForm(false);
  const onContactFormSubmit = () => {
    setCredits(1);
    setFormSubmitted(true);
    setShowContactForm(false);
  };

  return (
    <div className="relative flex flex-col lg:flex-row items-center justify-center min-h-screen bg-[#F3F4F6] p-6 overflow-hidden mt-16">
      <TopContent />

      <motion.div
        className="absolute top-20 left-20 w-36 h-36 bg-[#E5E7EB] rounded-full filter blur-xl opacity-70"
        animate={{ y: [0, 20, -20], x: [0, -10, 10] }}
        transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-1/4 right-20 w-24 h-24 bg-[#D1D5DB] rounded-full filter blur-lg opacity-70"
        animate={{ y: [0, -10, 10], x: [0, 10, -10] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
      />

      {!result && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative z-10 bg-white rounded-lg shadow-2xl w-full max-w-lg p-8 space-y-6 mr-4 lg:mr-10"
        >
          <h1 className="text-center text-black font-extrabold font-serif tracking-widest text-lg">
            Circle Rate Calculator
          </h1>

          <CityLocalityFields
            city={city}
            locality={locality}
            handleCityChange={handleCityChange}
            setLocality={setLocality}
          />

          <PropertyAreaFields
            propertyType={propertyType}
            area={area}
            unit={unit}
            setPropertyType={setPropertyType}
            setArea={setArea}
            setUnit={setUnit}
          />

          <UnitSelection unit={unit} setUnit={setUnit} />

          <motion.button
            onClick={onCalculateClick}
            className="bg-[#228b22] text-white py-3 font-bold px-3 rounded-xl hover:bg-green-700 mx-auto block"
            whileHover={{ scale: 1.05, transition: { yoyo: Infinity } }}
          >
            Calculate Circle Rate
            {/* {credits > 0 || formSubmitted
              ? `Calculate Circle Rate`
              : "Submit Contact Form to Proceed"} */}
          </motion.button>
        </motion.div>
      )}

      {result && (
        <motion.div
          className="relative z-10 bg-white rounded-lg shadow-2xl w-full max-w-lg p-8 space-y-6 mr-4 lg:mr-10"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <ResultCard result={result} />

          <motion.button
            onClick={handleReset}
            className="bg-gray-600 text-white py-2 font-bold px-3 rounded-lg hover:bg-green-500 mx-auto block"
            whileHover={{ scale: 1.05, transition: { yoyo: Infinity } }}
          >
            Reset Calculator
          </motion.button>
        </motion.div>
      )}

      <ContactFormModal
        showContactForm={showContactForm}
        closeContactForm={closeContactForm}
        onContactFormSubmit={onContactFormSubmit}
      />
    </div>
  );
};

export default CircleRateCalculator;
